import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import type { ClickedItem, OnMenuClickCallback } from '../../models';
import type { MenuItem } from '../../schemas/menuItemSchema';
import { AccordionMenuItem } from './AccordionMenuItem';

export interface AccordionMenuProps {
  menuItems: MenuItem[];
  menuClickedItem: ClickedItem;
  onMenuClick: OnMenuClickCallback;
}

export const AccordionMenu: FC<AccordionMenuProps> = ({ menuItems, menuClickedItem, onMenuClick }) => {
  const { getTestIdProps } = useTestId();

  return (
    <ul
      key="AccordionMenu"
      {...getTestIdProps('AccordionMenu')}
    >
      {menuItems.map((item) => (
        <AccordionMenuItem
          key={`accordion-${item.itemPath}`}
          menuItem={item}
          menuClickedItem={menuClickedItem}
          onMenuClick={onMenuClick}
        />
      ))}
    </ul>
  );
};
